import { errors as amwellErrors } from '../constants';

interface Validation {
  fieldName: string;
  reason: string;
  recoverySuggestion: string;
  errorCode: string;
}

export default class ValidationError extends Error {
  readonly method: string;
  readonly errorCode: string;
  readonly errors: Validation | Validation[];

  constructor(method: string, errors: Validation | Validation[]) {
    super();
    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, ValidationError);
    }

    this.name = 'ValidationError';
    this.method = method;
    this.errorCode = amwellErrors.VALIDATION_ERROR;
    this.errors = errors;
  }
}
